import api from './api';
export const policyEngineService = {
    // ── Policy CRUD (always scoped to authenticated merchant) ──────────────────
    listPolicies(filters = {}) {
        return api.get('/api/engine/policies', { params: filters });
    },
    getPolicy(id) {
        return api.get(`/api/engine/policies/${id}`);
    },
    /**
     * merchant_id is NOT sent — the backend always uses the authenticated user's ID
     * for subscriber roles. Admins may pass merchant_id explicitly.
     */
    createPolicy(policy) {
        return api.post('/api/engine/policies', policy);
    },
    updatePolicy(id, policy) {
        return api.put(`/api/engine/policies/${id}`, policy);
    },
    deletePolicy(id) {
        return api.delete(`/api/engine/policies/${id}`);
    },
    togglePolicy(id, enabled) {
        return api.put(`/api/engine/policies/${id}`, { enabled });
    },
    // ── Dry-run evaluate (test a context without creating an RMA) ──────────────
    dryRunEvaluate(context) {
        return api.post('/api/engine/policies/evaluate', context);
    },
    // ── Evaluation audit log ───────────────────────────────────────────────────
    listEvaluations(params = {}) {
        return api.get('/api/engine/evaluations', { params });
    },
};
